<template>
  <div class="cookie-banner" v-show="showCookieBanner">
    <span class="cookie-banner-message">MikMak uses cookies to enhance your experience on our site. By browsing our site, you agree to our <a href="/privacy">privacy policy</a>.</span>
    <span class="cookie-banner-dismiss" v-on:click="hideCookieBanner"> <span class="dismiss-text">dismiss</span> <i class="fa fa-close"></i> </span>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showCookieBanner: true,
      cookieName: 'cookieBannerAccepted'
    }
  },
  mounted() {
    let cookieAccepted = window.localStorage.getItem(this.cookieName)
    if (cookieAccepted) this.hideCookieBanner()
  },
  methods: {
    hideCookieBanner() {
      this.showCookieBanner = false
      window.localStorage.setItem(this.cookieName, true)
    }
  },
  computed: {},
  watch: {}
}
</script>

<style scoped>

  .cookie-banner {
    font-family: 'Work Sans', sans-serif;
    display: block;
    position: fixed;
    bottom: 0;
    z-index: 4;
    background: #409dd4;
    background: #00a9bc;
    background: linear-gradient(135deg, #24af94 0%,#31c4a8 69%,#19d09d 100%);
    color: white !important;
    font-size: 12px;
    left: 0;
    right: 0;
    padding: 12px;
    text-align: center;
    white-space: nowrap;
  }

  .cookie-banner a {
    color: white;
  }

  .cookie-banner-message {
    display: inline-block;
    width: 90%;
    white-space: normal;
    text-align: center;
  }

  @media only screen and (max-width: 650px) {
    .cookie-banner-message {
      text-align: left;
    }
    .dismiss-text {
      display: none;
    }
  }

  .cookie-banner-dismiss {
    width: 10%;
    display: inline-block;
    text-align: center;
    cursor: pointer;
    vertical-align: top;
  }


</style>



// WEBPACK FOOTER //
// CookieBanner.vue?349f4122